import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

type State = typeof initialState;

function handleSuccess(state: State): State {
  return {
    ...state,
    queue: updateNotification(
      {
        key: "addResourceToResourceGroup",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  };
}

function handleFailure(state: State): State {
  return {
    ...state,
    queue: updateNotification(
      {
        key: "addResourceToResourceGroup",
        flags: ["failure"],
        args: { failure: "true" },
      },
      state.queue,
    ),
  };
}

// Adding everyone shows the same notification as adding one resource.
const reduceAddResourceToResourceGroupNotificationState = createStateReducer(
  initialState,
  {
    [events.addResourceToResourceGroupSucceeded]: handleSuccess,
    [events.addResourceToResourceGroupFailed]: handleFailure,
    [events.addEveryoneToResourceGroupSucceeded]: handleSuccess,
    [events.addEveryoneToResourceGroupFailed]: handleFailure,
  },
);

export { reduceAddResourceToResourceGroupNotificationState };
